"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_bootstrap_1 = require("react-bootstrap");
const HeaderPart_1 = require("./HeaderPart");
const PartnersPart_1 = require("../../components/PartnersPart");
const Testimonial_1 = require("./Testimonial");
const PromoteAndManage_1 = require("./PromoteAndManage");
const ContactUsPart_1 = require("../../components/ContactUsPart");
const FooterPart_1 = require("../../components/FooterPart");
const AttractLoyalLocalCustomers_1 = require("./AttractLoyalLocalCustomers");
const DocumentTitle = require("react-document-title");
class HomeLanding extends React.Component {
    render() {
        return React.createElement(DocumentTitle, { title: "LoyalReach - We make personalized, Small Business Marketing Easy" }, React.createElement(react_bootstrap_1.Grid, { fluid: true, className: "landing-main" }, React.createElement(HeaderPart_1.default, null), React.createElement(PromoteAndManage_1.default, null), React.createElement(AttractLoyalLocalCustomers_1.default, null), React.createElement(Testimonial_1.default, null), React.createElement(PartnersPart_1.default, null), React.createElement(ContactUsPart_1.default, null), React.createElement(FooterPart_1.default, null)));
    }
}
exports.default = HomeLanding;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/home/components/HomeLanding.tsx
// module id = 1105
// module chunks = 0 1